<template>
  <div
    class="customer-display"
    :style="{ backgroundImage: pictureUrl ? `url(${pictureUrl})` : 'none' }"
  >
    <div v-if="!isUserLoggedIn">User is not logged in, screen is sleeping</div>
    <!-- We only render CustomerBasket if basketData object is fully prepared, its preparation is asynchrounous so we avoid passing undefined to CustomerBasket -->
    <CustomerBasket
      v-if="basketData"
      :key="componentBasketKey"
      :basketData="basketData"
      ref="customerBasket"
    />
    <div v-if="renderCustomerSeatingChart">
      <CustomerSeatingChart :chartData="chartData" ref="customerSeatingChart" />
    </div>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent, ref } from "vue";
// modules
import AuthModule from "@/store/modules/auth";
// components
import { isUserLoggedIn } from "@/utils/vue-helpers/user";

import CustomerSeatingChart from "@/views/Customer-Display/components/CustomerSeatingChart.vue";
import CustomerBasket from "@/views/Customer-Display/components/CustomerBasket.vue";
import { LogService } from "@/services/logging";
import { getCustomerBasketData } from "@/utils/vue-helpers/customer-display";
import POSConfigModule from "@/store/modules/pos-config";

export default defineComponent({
  name: "CustomerDisplay",
  components: { CustomerSeatingChart, CustomerBasket },
  setup() {
    console.log("hi from setup of CustomerDisplay");
    // creating a reference to the component CustomerSeatingChart
    // so that we can trigger CustomerSeatingChart.selectObjects() & CustomerSeatingChart.deselectObjects() functions
    const customerSeatingChart = ref<InstanceType<
      typeof CustomerSeatingChart
    > | null>(null);

    // so that we can trigger the component CustomerBasket to force re-render by increasing its key
    const customerBasket = ref<InstanceType<typeof CustomerBasket> | null>(
      null
    );
    const componentBasketKey = ref(0);
    const basketData = ref(null);
    console.log("basketData");
    console.log(basketData);
    let renderCustomerSeatingChart = ref<boolean>(false);
    let chartData = ref<any>(null);
    // let customerBasketSetupFunction = ref<any>(setupAsideOrderSummary());
    const isAuth = computed(() => {
      return AuthModule.getIsAuth;
    });

    function addSelectedSeatsOnChart(newlySelectedSeats: string[]) {
      customerSeatingChart.value?.selectObjects(newlySelectedSeats);
    }

    function removeSelectedSeatsOnChart(deselectedSeats: string[]) {
      customerSeatingChart.value?.deselectObjects(deselectedSeats);
    }

    function forceBasketRerendering() {
      console.log("hi from forceBasketRerendering");
      componentBasketKey.value += 1; // Incrementing the key forces re-render of XXX
    }

    const pictureUrl = computed(() => {
      return POSConfigModule.configPictureUrl;
    });

    return {
      isUserLoggedIn,
      isAuth,
      renderCustomerSeatingChart,
      chartData,
      customerSeatingChart,
      addSelectedSeatsOnChart,
      removeSelectedSeatsOnChart,
      customerBasket,
      componentBasketKey,
      forceBasketRerendering,
      basketData,
      pictureUrl,
    };
  },
  async beforeMount() {
    console.log("hi from beforeMount of customer-display");
    this.basketData = await getCustomerBasketData();
    console.log("this.basketData");
    console.log(this.basketData);
  },
  async mounted() {
    console.log("hi from mounted of customer-display");
    // Assigning a value to the basketData when the customer display is mounted, it will be updated once user update the booking
    // Creating a broadcastChannel object linked to pos.smeetz
    const broadcastChannel = new BroadcastChannel("pos.smeetz");
    // listenning to the channel pos.smeetz
    broadcastChannel.onmessage = async (event) => {
      console.log("broadcastchannel onmessage of customer-display");
      const receivedData = JSON.parse(event.data);
      console.log("receivedData");
      console.log(receivedData);
      LogService.info("Attached data received in broadcast channel", {
        params: receivedData,
      });
      if (receivedData.isChartToUpdate) {
        this.renderCustomerSeatingChart =
          receivedData.renderCustomerSeatingChart;
        this.closeChartInCustomerDisplay =
          receivedData.closeChartInCustomerDisplay;
        this.chartData = receivedData.chartData;
      }
      if (receivedData.isBookingUpdated) {
        // console.log("so booking was actually updated");
        // Here we update CustomerBasket, and we may update a chart if already opened in case user selected/deseelcted seats
        console.log("Booking is updated, we received basket data");
        console.log("receivedData");
        console.log(receivedData);
        console.log("receivedData.customerBasketData");
        console.log(receivedData.customerBasketData);
        if (receivedData.customerBasketData) {
          this.basketData = receivedData.customerBasketData;
        } else {
          console.error("something is wrong");
        }

        // 1- checking for newly selected seats
        if (
          receivedData.newlySelectedSeats &&
          receivedData.newlySelectedSeats.length
        ) {
          // So user has just selected new seats, lets select them in the already shown chart
          // do it by triggering a function inside CustomerSeatingChart and passing newlySelectedSeats variable
          this.addSelectedSeatsOnChart(receivedData.newlySelectedSeats);
        }

        // 2- checking for newly deselected seats
        if (
          receivedData.deselectedSeats &&
          receivedData.deselectedSeats.length
        ) {
          // So user has just deselected seats, lets deselect them in the already shown chart
          // do it by triggering a function inside CustomerSeatingChart and passing deselectedSeats variable
          this.removeSelectedSeatsOnChart(receivedData.deselectedSeats);
        }
      }
    };
  },
});
</script>
<style lang="scss" scoped>
.customer-display {
  background-color: #3d3f45;
  display: flex;
  width: 100%;
  background-size: auto 100%;
  background-position: right;
  background-repeat: no-repeat;
}
</style>
